import Modal from "@/src/views/components/Modal";
import Paper from "@/src/views/components/Paper";
import styles from "./index.module.scss";
import Button from "@/src/views/components/Button";
import Typography from "@/src/views/components/Typography";
import { Fragment } from "react";

export default function ModalDetailProduct({
  modalState,
  handleClose,
  selectedData = {
    product_name: "WISE",
    product_functions: ["Data", "API", "Web"],
  },
}: {
  modalState: boolean;
  handleClose: () => void;
  selectedData?: { product_name: string; product_functions: string[] };
}) {
  return (
    <Modal open={modalState} handleOutside={handleClose}>
      <Paper width={"80vw "} padding={24}>
        <div className={styles["paper-container"]}>
          <div className={styles["main-section"]}>
            <div className={styles["main-left-side"]}>
              <Typography variant="heading-6-bold" color="dark40">
                {selectedData?.product_name}
              </Typography>
              <div className={styles["product-function-list"]}>
                {selectedData?.product_functions?.map((item, id) => (
                  <Fragment key={id}>
                    <div className={styles["box-function"]}>
                      <Typography
                        color="green100"
                        variant="subtitle-4-demibold"
                      >
                        {item}
                      </Typography>
                    </div>
                  </Fragment>
                ))}
              </div>
              <Typography variant="subtitle-6-medium" color="light80">
                {`Web berbasis AI yang menampung informasi dan pengetahuan
                (knowledge) berbagai produk BRI dan menyediakan Working
                Instruction yang dibutuhkan oleh frontliner ataupun customer
                service dalam memberikan layanan seputar BRI ke nasabah`}
              </Typography>
              <div className={styles["contact-section"]}>
                <Typography
                  variant="subtitle-3-demibold"
                  color="dark30"
                >{`Service & Contact Center Division (SCC)`}</Typography>
              </div>
            </div>
            <img
              src={`${process.env.NEXT_PUBLIC_IMAGES}/product-image-wise.svg`}
              alt=""
              width={"100%"}
            />
          </div>
          <div className={styles["footer-section"]}>
            <Button text="Tutup" baseColor="blue" onClick={handleClose} />
          </div>
        </div>
      </Paper>
    </Modal>
  );
}
